import { defineComponent as _defineComponent } from 'vue'
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { FormDefinition, FormEvent } from 'ah-common-lib/src/form/interfaces';
import { textField } from 'ah-common-lib/src/form/models';
import { Beneficiary, PurposeCodeResponse, beneficiaryName } from 'ah-api-gateways';
import { computed, reactive, watch } from 'vue';
/**
 * Payment reason form for payment processing
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentReasonForm',
  props: {
    reason: { default: '' },
    narrow: { type: [String, Boolean], default: false },
    beneficiary: null
  },
  emits: ["update:reason"],
  setup(__props: any, { expose, emit }: { emit: ({
  /**
   * Emitted when `reason` changes. Value emitted also depends on `beneficiary` value. Can be used with v-model
   */
  (e: 'update:reason', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { reason: string | null, narrow: string | boolean, beneficiary?: Beneficiary };





const txReasonFormDef = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'txReason',
    fieldType: 'form',
    fields: [textField('reason', '', { required: false, maxLength: 50, showLengthCounter: true })],
  }),
  validation: null,
});

const state = reactive<{
  purposeCodes: PurposeCodeResponse | null;
  reasonValue: string | null;
}>({
  purposeCodes: null,
  reasonValue: '',
});

const isNarrow = computed(() => props.narrow !== false);

const valid = computed(() => {
  if (props.beneficiary?.purposeCode) {
    return true;
  }
  if (txReasonFormDef.validation) {
    return !txReasonFormDef.validation.$invalid;
  }
  return true;
});

watch(
  () => state.reasonValue,
  () => {
    txReasonFormDef.form.reason = state.reasonValue;
    emitValue();
  },
  { immediate: true }
);

watch(
  () => props.reason,
  () => {
    state.reasonValue = props.reason;
  },
  { immediate: true }
);

watch(
  () => props.beneficiary,
  () => {
    if (props.beneficiary) {
      if (!txReasonFormDef.validation?.reason?.$dirty) {
        state.reasonValue = `Payment sent to ${beneficiaryName(props.beneficiary)}`;
      }

      // Value needs to be emmitted in the next JS frame, to allow all watchers to run beforehand
      setTimeout(() => emitValue());
    }
  },
  { immediate: true }
);

function touchForms() {
  if (txReasonFormDef.validation) {
    submitForm(txReasonFormDef.validation);
  }
}

function onFormEvent(formEvent: FormEvent) {
  if (formEvent.event === 'form-field-set-value') {
    state.reasonValue = txReasonFormDef.form.reason;
    emitValue();
  }
}

function emitValue() {
  emit('update:reason', txReasonFormDef.form.reason);
}

expose({ valid: valid.value, touchForms });

return { __sfc: true,props, emit, txReasonFormDef, state, isNarrow, valid, touchForms, onFormEvent, emitValue }
}

})